function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  fill: "rgb(80, 80, 80)",
  d: "M9.731,4.397 L5.580,0.247 C5.252,-0.081 4.721,-0.081 4.394,0.247 C4.067,0.574 4.067,1.105 4.394,1.432 L7.952,4.989 L4.394,8.546 C4.067,8.873 4.067,9.404 4.394,9.731 C4.721,10.059 5.252,10.059 5.580,9.731 L9.731,5.581 C10.059,5.255 10.059,4.724 9.731,4.397 ZM4.740,4.146 L1.444,0.673 C1.113,0.324 0.576,0.324 0.245,0.673 C-0.086,1.021 -0.086,1.587 0.245,1.936 L2.942,4.777 L0.245,7.618 C-0.086,7.967 -0.086,8.532 0.245,8.881 C0.576,9.229 1.113,9.229 1.444,8.881 L4.740,5.408 C5.071,5.060 5.071,4.494 4.740,4.146 Z"
});

var SvgLastPage = function SvgLastPage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "10px",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLastPage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lastPage.ad5acf79.svg";
export { ForwardRef as ReactComponent };